import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import Accordion from "../../../common/accordion";
import useJetliftCollapseFacade from "../../../../facade/jetlift/collapse/collapse.facade";
import useInputValidations from "../InputValidations";

const Others: React.FC = () => {
    const {
        getdefaultCollapse,
        handleCollapseChange,
    } = useJetliftCollapseFacade();
    const [form, setForm] = useState<{ [key: string]: string }>({});
    const { register, control } = useFormContext();
    const { sectionsData, renderField } = useInputValidations();

    const handleChange = (label: string, value: string) => {
        setForm((prev) => ({ ...prev, [label]: value }));
    };

    return (
        <div className="flex flex-col gap-[16px]">
            {sectionsData?.others?.map((section, secIdx) => (
                <div
                    key={secIdx}
                    className="flex flex-col"
                >
                    <Accordion
                        title={section?.section}
                        isOpen={getdefaultCollapse(section?.section) ?? false}
                        onToggle={() => handleCollapseChange(!getdefaultCollapse(section?.section), section?.section)}
                        content={
                            <div className="flex flex-col gap-[16px] p-[12px]">
                                {section?.fields?.map((field, idx) => (
                                    <div key={idx}>
                                        {renderField(field, form, handleChange, register, control)}
                                    </div>
                                ))}
                            </div>
                        }
                    />
                </div>
            ))}
        </div>
    );
};

export default Others;